import React from 'react';
import { MenuIcon, SearchIcon, UserIcon } from 'lucide-react';
export function EditorialHeader() {
  return <header className="border-b border-gray-200 bg-white" data-id="element-26">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="flex justify-between items-center h-16" data-id="element-28">
          {/* Left: Search (Mobile/Desktop) */}
          <div className="flex items-center space-x-4" data-id="element-29">
            <button className="p-2 text-gray-600 hover:text-gray-900 transition-colors hidden sm:block" data-id="element-30">
              <SearchIcon className="h-5 w-5" data-id="element-31" />
              <span className="sr-only" data-id="element-32">Search</span>
            </button>
          </div>

          {/* Center: Logo */}
          <div className="flex-shrink-0 flex flex-col items-center" data-id="element-33">
            <h1 className="text-xl md:text-2xl font-bold font-serif tracking-tight text-slate-900" data-id="element-34">
              Living & Wellness
            </h1>
            <span className="text-[10px] uppercase tracking-widest text-gray-500 font-medium mt-0.5" data-id="element-35">
              Est. 2018
            </span>
          </div>

          {/* Right: User/Subscribe */}
          <div className="flex items-center space-x-4" data-id="element-36">
            <span className="text-xs font-semibold tracking-wider text-gray-400 border border-gray-200 px-2 py-1 rounded uppercase" data-id="element-37">
              Advertorial
            </span>
            <button className="p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-38">
              <UserIcon className="h-5 w-5" data-id="element-39" />
              <span className="sr-only" data-id="element-40">Account</span>
            </button>
          </div>
        </div>
      </div>

      {/* Sub-nav (Desktop only) */}
      <nav className="hidden md:block border-t border-gray-100 py-2 bg-[#FAFAF7]" data-id="element-41">
        <ul className="flex justify-center space-x-8 text-xs font-medium uppercase tracking-wider text-gray-600" data-id="element-42">
          <li className="hover:text-slate-900 cursor-pointer" data-id="element-43">Health</li>
          <li className="hover:text-slate-900 cursor-pointer" data-id="element-44">Lifestyle</li>
          <li className="hover:text-slate-900 cursor-pointer" data-id="element-45">Family</li>
          <li className="hover:text-slate-900 cursor-pointer" data-id="element-46">Food</li>
          <li className="hover:text-slate-900 cursor-pointer" data-id="element-47">Tech</li>
          <li className="hover:text-slate-900 cursor-pointer" data-id="element-48">Reviews</li>
        </ul>
      </nav>
    </header>;
}